import React from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { useDeleteQuizFolder } from '~teacher/hook/useDeleteQuizFolder';

import {
  DeleteQuizFolderParam,
  DeleteQuizFolderResponse,
} from '../../../../api/quiz';
import { reduceUniqueIdsToObject } from '../../../../api/quiz/getQuizzes/normalize/uniqueIds';

type OnError = (
  error?: unknown,
  variables?: DeleteQuizFolderParam,
  context?: unknown
) => void | Promise<unknown>;

type OnSuccess = (
  data?: DeleteQuizFolderResponse,
  variables?: DeleteQuizFolderParam,
  context?: unknown
) => void | Promise<unknown>;

export function useDeleteSelectedQuizFolder() {
  const queryClient = useQueryClient();
  const deleteQuizFolder = useDeleteQuizFolder();

  const deleteSelectedQuizFolder = React.useCallback(
    ({
      selectedQuizItem,
      onError,
      onSuccess,
    }: {
      selectedQuizItem: string[];
      onError?: OnError;
      onSuccess?: OnSuccess;
    }) => {
      const groupedById = reduceUniqueIdsToObject([
        ...new Set(selectedQuizItem),
      ]);
      deleteQuizFolder.mutate(
        {
          folderIds: [...(groupedById.folder ?? [])],
          quizIds: [...(groupedById.quiz ?? [])],
        },
        {
          onSuccess: () => {
            queryClient.invalidateQueries(['quiz']);
            onSuccess?.();
          },
          onError: (error) => {
            onError?.(error);
          },
        }
      );
    },
    [deleteQuizFolder, queryClient]
  );

  return { deleteSelectedQuizFolder };
}
